import {
  KeyboardAvoidingView,
  Platform,
  SafeAreaView,
  ScrollView,
  StyleSheet,
} from 'react-native';
import { SelectedSetsData } from '../../components/SetsSelectedData';
import { useWordsetContext } from '../../hooks/useWordsetContext';
import { Filter } from './Filter';
import { Header } from './Header';

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  scrollStyle: {
    flex: 1,
    margin: 15,
  },
});

export function SetsSelectedWrapper({ props }) {
  const {
    data,
    selectedWords,
    changeSelectedData,
    patientId,
    page,
    changePage,
    limitModal,
    changeLimitModal,
    setId,
    editData,
    dataKeyName,
    apiKeyName,
    dynamicName,
    scrollViewRef,
  } = useWordsetContext();

  const propz = {
    data,
    selectedData: selectedWords,
    changeSelectedData,
    patientId,
    page,
    changePage,
    limitModal,
    changeLimitModal,
    setId,
    editData,
    dataKeyName,
    apiKeyName,
    dynamicName,
    props,
  };

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : undefined}
      style={{ flex: 1 }}
      keyboardVerticalOffset={Platform.OS === 'ios' ? 80 : 0}
    >
      <SafeAreaView style={styles.container}>
        <Header props={props} />
        <ScrollView ref={scrollViewRef} style={styles.scrollStyle}>
          <Filter />
          <SelectedSetsData type="word" {...propz} />
        </ScrollView>
      </SafeAreaView>
    </KeyboardAvoidingView>
  );
}
